export const moveForward = (currentStep, setCurrentStep, lastStep, setPreveStep) => {
  if (currentStep === lastStep) return setCurrentStep(0);
  else { return setCurrentStep((prevStep) => currentStep + 1), setPreveStep((prevStep) => currentStep + 1)}
};
